var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.256 17.4999L17.176 13.4199C18.596 10.5299 18.116 6.91988 15.706 4.51988C12.686 1.49988 7.76596 1.49988 4.74596 4.51988C1.72596 7.53988 1.72596 12.4599 4.74596 15.4799C6.25596 16.9899 8.24596 17.7499 10.226 17.7499C11.396 17.7499 12.566 17.4799 13.646 16.9499L17.726 21.0299C18.196 21.4999 18.826 21.7599 19.486 21.7599C20.146 21.7599 20.776 21.4999 21.246 21.0299C22.216 20.0599 22.216 18.4799 21.246 17.4999H21.256ZM5.80596 14.4199C3.36596 11.9799 3.36596 8.01988 5.80596 5.57988C7.02596 4.35988 8.62596 3.74988 10.226 3.74988C11.826 3.74988 13.426 4.35988 14.646 5.57988C17.086 8.01988 17.086 11.9799 14.646 14.4199C12.206 16.8599 8.24596 16.8599 5.80596 14.4199ZM20.196 19.9699C19.816 20.3499 19.166 20.3499 18.786 19.9699L14.946 16.1299C15.206 15.9299 15.456 15.7199 15.696 15.4799C15.936 15.2399 16.146 14.9899 16.346 14.7299L20.186 18.5699C20.576 18.9599 20.576 19.5899 20.186 19.9799L20.196 19.9699Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.89b89e80afafbb290dd54ce34eb0ee2f.svg";
export { ForwardRef as ReactComponent };